import { type FC } from 'react';
import { useRegisterRoute } from '@/registration/hook/useRegisterRoute';
import AddToCalendarComponent from '@/registration/component/shared/AddToCalendarButton';
import { UiStack, uiStyles } from '@/lib/ui';
import { useEventQuery } from '@/registration/hook/useEventQuery';
import RegisterLayout from '@/registration/component/Register/Layout';
import BaseLoadingSpinner from '@/base/Loading/Spinner';

const AddToCalendarPage: FC = () => {
  const { eventId } = useRegisterRoute();
  const { data: event, isLoading } = useEventQuery(eventId);

  if (isLoading) {
    return (
      <UiStack p={8}>
        <BaseLoadingSpinner size={'md'}/>
      </UiStack>
    );
  }

  return (
    <RegisterLayout
      enableHeader={false}
    >
      <UiStack
        alignItems={'stretch'}
        borderRadius={uiStyles.borderRadius}
        spacing={0}
        flexGrow={1}
      >
        {event && (
          <UiStack alignItems="center" justifyContent="center" flexGrow={1} m={4}>
            <AddToCalendarComponent event={event} />
          </UiStack>
        )}
      </UiStack>
    </RegisterLayout>
  );
};

export default AddToCalendarPage;
